// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3w-1";
export var movingGradient = "_3w-4";
export var movingGradientBlock = "_3w-2";
export var skeleton = "_3w-0";
export var skeletonText = "_3w-3";